import moment from "moment";
import { i18n } from "../translate/i18n";

type TCalendarEvent = {
  day: number,
  month: number,
  year: number,
  _id: number,
  totalEvents: number,
}

type calendarEvents = {
  servicesInProgress: TCalendarEvent[],
  servicesCompleted: TCalendarEvent[],
  actionsInProgress: TCalendarEvent[],
  actionsCompleted: TCalendarEvent[],
  maintenances: TCalendarEvent[]
}

const formatNewCalendarEvents = ({
  servicesInProgress,
  servicesCompleted,
  actionsInProgress,
  actionsCompleted,
  maintenances,
}: calendarEvents) => {

  const servicesInProgressEvents = servicesInProgress.map((service) => {
    const date = new Date(service.year, service.month - 1, service.day);
    const quantity = service.totalEvents;
    const type = 'service';
    if (moment(date).isSameOrAfter(moment().startOf('day'))) {
      return {
        title: i18n.t('scheduledServicesOutput.title'),
        quantity,
        start: date,
        end: date,
        payload: [],
        stage: 'scheduled',
        type,
      }
    } else {
      return {
        title: i18n.t('scheduledServicesOutput.title1'),
        quantity,
        start: date,
        end: date,
        payload: [],
        stage: 'overdue',
        type,
      }
    }
  });

  const servicesCompletedEvents = servicesCompleted.map((service) => {
    const date = new Date(service.year, service.month - 1, service.day);    
    const quantity = service.totalEvents;
    return {
      title: i18n.t('doneServicesOutput.title'),
      quantity,
      start: date,
      end: date,
      payload: [],
      stage: 'done',
      type: 'service'
    }
  });

  const actionsInProgressEvents = actionsInProgress.map((action) => {
    const date = new Date(action.year, action.month - 1, action.day);
    const quantity = action.totalEvents;
    const type = 'action';
    if (moment(date).isSameOrAfter(moment().startOf('day'))) {
      return {
        title: i18n.t('doneActionsOutput.title2'),
        quantity,
        start: date,
        end: date,
        payload: [],
        stage: 'scheduled',
        type,
      }
    } else {
      return {
        title: i18n.t('doneActionsOutput.title1'),
        quantity,
        start: date,
        end: date,
        payload: [],
        stage: 'overdue',
        type,
      }
    }
  });

  const actionsCompletedEvents = actionsCompleted.map((action) => {
    const date = new Date(action.year, action.month - 1, action.day);
    const quantity = action.totalEvents;
    const type = 'action';
    return {
      title: i18n.t('doneActionsOutput.title'),
      quantity,
      start: date,
      end: date,
      payload: [],
      stage: 'done',
      type,
    }
  });

  const maintenancesEvents = maintenances.map((maintenance) => {
    const date = new Date(maintenance.year, maintenance.month - 1, maintenance.day);    
    const quantity = maintenance.totalEvents;        
    return {
      title: i18n.t('maintenancesOutput.title'),
      quantity,
      start: date,
      end: date,
      payload: [],
      stage: 'progress',
      type: 'maintenance'
    }
  })

  return [...actionsCompletedEvents, ...actionsInProgressEvents, ...servicesCompletedEvents, ...servicesInProgressEvents, ...maintenancesEvents];
};

export default formatNewCalendarEvents;
